class MultipleEmailValidator {
    constructor() {
      this.restrict = 'A';
      this.require = 'ngModel';
      this.scope = {};
  
      /**
       * Link
       * @param  {Object} scope
       * @param  {Object} element
       * @param  {Object} attrs
       * @param  {Array} requiredCtrls
       * @return {Void}
       */
      this.link = (scope, element, attrs, modelCtrl) => {
        modelCtrl.$validators.email = (modelValue) => {
          const EMAIL_REGEXP = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
  
          var validity =  modelValue === undefined || modelValue === null || modelValue === ''|| modelValue.split(';').every(
            function (email) {
                return EMAIL_REGEXP.test(email.trim());
            }
          );

    
          return validity ? true : false;
        };
  
      };
    }
  
    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory() {
      MultipleEmailValidator.instance = new MultipleEmailValidator();
      return MultipleEmailValidator.instance;
    }
  }
  
  export default MultipleEmailValidator;
  


/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/multipleEmailValidator.js
 **/